import { DisplayMagnitude } from '@snap-types/models/quoting-config/enums';
import { LeadTimeFormat } from '@snap-types/schemas/lead-time-format';
import type { QuoteBuilderStateType } from '@ui/features/quote-builder/types/state';
import type { QuoteBuilderInternalType } from '@ui/features/quote-builder/types/state/internal';

export const defaultInternalState = {
  isLoading: false,
  isUpdating: false,
  dialog: null,
  issues: {},
  isIssueDrawerOpen: false,
  canViewPDF: false,
  quoteLineConfiguratorSnapshot: null,
} as const satisfies QuoteBuilderInternalType;

export const defaultState: QuoteBuilderStateType = {
  ...defaultInternalState,
  calculationConfig: {
    decimalPlaces: 4,
  },
  leadTimeFormat: LeadTimeFormat.NUMBER,

  editMode: 'edit',
  sentAt: null,
  uuid: '',
  quoteId: '',
  versionUuid: '',
  versionCount: 0,
  siteCode: '',
  customerId: null,
  termsNetDays: null,
  priceStrategies: [],
  displayQuantity: DisplayMagnitude.ONES,
  discountCodes: null,
  marketCodes: null,

  salesRepName: null,
  salesRepEmail: null,
  salesRepPhone: null,
  csrName: null,
  csrEmail: null,

  name: null,
  salesRepId: null,
  csrOid: null,
  contactName: null,
  contactEmail: null,
  contactPhone: null,
  address1: null,
  address2: null,
  city: null,
  state: null,
  postalCode: null,
  countryCode: null,
  specs: null,
  notes: null,
  daysUntilQuoteExpires: null,
  daysUntilExpectedWin: null,
  customerQuoteId: null,
  discountCode: null,
  marketCode: null,
  wonLossStatus: null,
  quantityRange: null,

  quoteLineUuids: [],
  quoteLines: {},
};
